import React from 'react';
import BlockDiagram from '../BlockDiagram/BlockDiagram';
import { personalInfo, education, highlights } from '../../data/portfolioData';
import { stackDiagram } from '../../data/diagrams';
import { openAssistant } from '../../lib/assistantBus';
import './Intro.css';

const [grad, undergrad] = education;

const FACTS = [
  ['focus', 'Full-stack web, real-time systems, iOS'],
  ['studying', `${grad.degree}, ${grad.school}, through ${grad.duration.split(' to ')[1]}`],
  ['previously', `${undergrad.degree}, VJTI`],
  ['based', personalInfo.location]
];

export const Intro = () => (
  <section className="intro" id="top">
    <p className="section-path">index</p>
    <h1 className="intro-name">{personalInfo.name}</h1>
    <p className="intro-lede">{personalInfo.bio.short}</p>

    <div className="intro-actions">
      <a className="action action-solid" href={personalInfo.resume} target="_blank" rel="noreferrer">
        Resume
      </a>
      <a className="action" href={`mailto:${personalInfo.email}`}>
        Email me
      </a>
      <button type="button" className="action" onClick={() => openAssistant()}>
        Ask the assistant
      </button>
    </div>

    <dl className="facts">
      {FACTS.map(([key, value]) => (
        <div className="facts-row" key={key}>
          <dt>{key}</dt>
          <dd>{value}</dd>
        </div>
      ))}
    </dl>

    <h2 className="sub-head">Highlights</h2>
    <ul className="marks">
      {highlights.map((line) => (
        <li key={line}>{line}</li>
      ))}
    </ul>

    <BlockDiagram diagram={stackDiagram} />

    <h2 className="sub-head">About</h2>
    <div className="prose">
      {personalInfo.bio.detailed.map((para, i) => (
        <p key={i}>{para}</p>
      ))}
    </div>
  </section>
);

export default Intro;
